import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute, RequireRole, RequireMenu } from "./routes/ProtectedRoute";
import { AppShell } from "./shell/AppShell";

import LoginPage from "./pages/auth/LoginPage";
import SignupPage from "./pages/auth/SignupPage";
import PasskeysPage from "./pages/auth/PasskeysPage";
import DashboardPage from "./pages/dashboard/DashboardPage";
import NoticePage from "./pages/notice/NoticePage";
import NoticeDetailPage from "./pages/notice/NoticeDetailPage";
import NoticeWritePage from "./pages/notice/NoticeWritePage";
import ApprovalPage from "./pages/approval/ApprovalPage";
import AttendancePage from "./pages/attendance/AttendancePage";
import LeavePage from "./pages/leave/LeavePage";
import DirectoryPage from "./pages/directory/DirectoryPage";
import MailPage from "./pages/mail/MailPage";
import MailComposePage from "./pages/mail/MailComposePage";
import ChatPage from "./pages/chat/ChatPage";
import CalendarPage from "./pages/calendar/CalendarPage";
import ProjectsPage from "./pages/projects/ProjectsPage";
import TodosPage from "./pages/todos/TodosPage";
import DrivePage from "./pages/drive/DrivePage";
import ReferencesPage from "./pages/references/ReferencesPage";
import ExpensePage from "./pages/expense/ExpensePage";
import CrmPage from "./pages/crm/CrmPage";
import FinancePage from "./pages/finance/FinancePage";
import BiPage from "./pages/bi/BiPage";
import PayrollPage from "./pages/payroll/PayrollPage";
import NotificationsPage from "./pages/notifications/NotificationsPage";
import SettingsPage from "./pages/settings/SettingsPage";
import AdminPage from "./pages/admin/AdminPage";
import ExecHrPage from "./pages/exec/ExecHrPage";
import ExecBizPage from "./pages/exec/ExecBizPage";
import ExecDocsPage from "./pages/exec/ExecDocsPage";

import PlanningPage from "./pages/extras/PlanningPage";
import ProgramsPage from "./pages/extras/ProgramsPage";
import ProgramDetailPage from "./pages/extras/ProgramDetailPage";
import ConverterPage from "./pages/programs/ConverterPage";
import VideoSpeedPage from "./pages/programs/VideoSpeedPage";
import SubtitlePage from "./pages/programs/SubtitlePage";
import YoutubePage from "./pages/programs/YoutubePage";
import RemoveBgPage from "./pages/programs/RemoveBgPage";
import DraftPage from "./pages/programs/DraftPage";
import SpacesPage from "./pages/programs/SpacesPage";
import ScriptStudioPage from "./pages/programs/ScriptStudioPage";
import ProposalPage from "./pages/extras/ProposalPage";
import BoardPage from "./pages/extras/BoardPage";
import BoardDetailPage from "./pages/extras/BoardDetailPage";
import FavoritesPage from "./pages/extras/FavoritesPage";
import DocStudioPage from "./pages/docstudio/DocStudioPage";
import DocViewerPage from "./pages/docstudio/DocViewerPage";
import TeamDocsShell from "./pages/docstudio/TeamDocsShell";

export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<LoginPage/>}/>
      <Route path="/signup" element={<SignupPage/>}/>

      {/* '팀_문서' 앱 — 문서 관리만(레일·메뉴 없는 틀) */}
      <Route element={<ProtectedRoute><TeamDocsShell/></ProtectedRoute>}>
        <Route path="/teamdocs" element={<DocStudioPage/>}/>
        <Route path="/teamdocs/view/:id" element={<DocViewerPage/>}/>
      </Route>

      {/* App */}
      <Route element={<ProtectedRoute><AppShell/></ProtectedRoute>}>
        <Route path="/" element={<Navigate to="/dashboard" replace/>}/>
        <Route path="/dashboard" element={<DashboardPage/>}/>
        <Route path="/notice" element={<NoticePage/>}/>
        <Route path="/notice/new" element={<NoticeWritePage/>}/>
        <Route path="/notice/:id" element={<NoticeDetailPage/>}/>
        <Route path="/notice/:id/edit" element={<NoticeWritePage/>}/>

        {/* Collaboration */}
        <Route path="/mail" element={<MailPage/>}/>
        <Route path="/mail/compose" element={<MailComposePage/>}/>
        <Route path="/chat" element={<ChatPage/>}/>
        <Route path="/calendar" element={<CalendarPage/>}/>

        {/* Work */}
        <Route path="/projects" element={<ProjectsPage/>}/>
        <Route path="/todos" element={<TodosPage/>}/>
        <Route path="/drive" element={<DrivePage/>}/>
        <Route path="/approval" element={<ApprovalPage/>}/>
        <Route path="/references" element={<ReferencesPage/>}/>
        <Route path="/docstudio" element={<DocStudioPage/>}/>
        <Route path="/docstudio/view/:id" element={<DocViewerPage/>}/>

        {/* HR / Ops */}
        <Route path="/attendance" element={<AttendancePage/>}/>
        <Route path="/leave" element={<LeavePage/>}/>
        <Route path="/directory" element={<DirectoryPage/>}/>
        <Route path="/payroll" element={<PayrollPage/>}/>

        {/* Finance / BI */}
        <Route path="/expense" element={<ExpensePage/>}/>
        <Route path="/crm" element={<CrmPage/>}/>
        <Route path="/finance" element={<RequireRole role="FINANCE_ADMIN"><FinancePage/></RequireRole>}/>
        <Route path="/executive" element={<RequireRole role="C_LEVEL"><BiPage/></RequireRole>}/>

        {/* Exec-only internal ops */}
        <Route path="/exec/hr"   element={<RequireRole role="C_LEVEL"><ExecHrPage/></RequireRole>}/>
        <Route path="/exec/biz"  element={<RequireRole role="C_LEVEL"><ExecBizPage/></RequireRole>}/>
        <Route path="/exec/docs" element={<RequireRole role="C_LEVEL"><ExecDocsPage/></RequireRole>}/>

        {/* Etc */}
        <Route path="/notifications" element={<NotificationsPage/>}/>
        <Route path="/settings" element={<SettingsPage/>}/>
        <Route path="/auth/webauthn" element={<PasskeysPage/>}/>

        {/* Ops */}
        <Route path="/favorites" element={<FavoritesPage/>}/>
        <Route path="/board" element={<BoardPage/>}/>
        <Route path="/board/:id" element={<BoardDetailPage/>}/>

        {/* Design-only stubs */}
        <Route path="/planning" element={<PlanningPage/>}/>
        <Route path="/programs" element={<ProgramsPage/>}/>
        <Route path="/programs/speed" element={<VideoSpeedPage/>}/>
        <Route path="/programs/converter" element={<ConverterPage/>}/>
        <Route path="/programs/subtitle" element={<SubtitlePage/>}/>
        <Route path="/programs/youtube" element={<YoutubePage/>}/>
        <Route path="/programs/removebg" element={<RemoveBgPage/>}/>
        <Route path="/programs/draft" element={<DraftPage/>}/>
        <Route path="/programs/spaces" element={<SpacesPage/>}/>
        <Route path="/programs/script" element={<ScriptStudioPage/>}/>
        <Route path="/programs/:id" element={<ProgramDetailPage/>}/>
        <Route path="/proposal" element={<ProposalPage/>}/>

        {/* Admin — SUPER_ADMIN(전체) 또는 실장+(메뉴 권한 관리만) */}
        <Route path="/admin" element={<RequireMenu anyOf={["system_admin", "menu_admin"]}><AdminPage/></RequireMenu>}/>
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
    </Routes>
  );
}
